export default (state) => state.app.user.id;
